import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Container,
  Grid,
  Typography,
  Box,
  Paper,
  Divider,
  MenuItem,
  List,
  ListItem,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import Select from "react-select";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
const EligibilityCheck = (props) => {
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const [payer, setPayer] = useState({
    value: "AARP",
    label: "AARP",
  });
  const [provider, setProvider] = useState("");
  const [benefitType, setBenefitType] = useState({
    value: "Health Benefit Plan Coverage",
    label: "Health Benefit Plan Coverage",
  });
  const [procedureCode, setProcedureCode] = useState("");
  const [lastName, setLastName] = useState(props.LastName);
  const [firstName, setFirstName] = useState(props.firstName);
  const [relationship, setRelationship] = useState(18);
  const [policyNumber, setPolicyNumber] = useState(props.memberId);
  const [dob, setDob] = React.useState(moment(props.Dob).format("YYYY-MM-DD"));
  const [dos, setDos] = useState("");

  const [Insurance, setInsurance] = useState([]);
  const [selectedInsurance, setSelectedInsurance] = useState(null);

  // useEffect(() => {
  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/Insurances/getInsurance`, {
  //       headers,
  //     })

  //     .then((response) => {
  //       var prov = [];
  //       response.forEach((field) => {
  //         prov.push({
  //           label: field.name,
  //           value: field.payerId,
  //         });
  //       });
  //       setInsurance(prov);
  //     })
  //     .catch((error) => {});
  // }, []);

  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
const [errors, setErrors] = useState({});
const [selectedPayer, setSelectedPayer] = useState(null);

  const handleSearch = async (value) => {
    setInputValue(value);
    if (!value) {
      setOptions([]);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Insurances/getInsuranceByName?Name=${value}`,
        { headers }
      );

      // format API response
      const formatted = response.map((item) => ({
        label: item.name,
        value: item.payerid,
      }));

      setOptions(formatted);
    } catch (error) {
      console.error("Error fetching insurance:", error);
      setOptions([]);
    }
    setLoading(false);
  };
  const highlightMatch = (text, query) => {
    if (!query) return text;
    const parts = text.split(new RegExp(`(${query})`, "gi"));
    return parts.map((part, i) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span
          key={i}
          style={{
            backgroundColor: "#fff176", // highlight color
            borderRadius: 2,
            padding: "0 2px",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };
  const handleSelect = (option) => {
    setSelectedInsurance(option);
    setSelectedPayer(option)
    setInputValue(option.label || option.value);
    setOptions([]);
     setErrors((prev) => ({
    ...prev,
    insurance: "",
  }));
  };
const validateForm = () => {
  let tempErrors = {};

  // Insurance validation
  if (!selectedPayer) {
    tempErrors.insurance = "Insurance Company is required";
  } else if (!selectedPayer.value) {
    tempErrors.insurance =
      "Selected insurance does not have a valid Payer ID";
  }

  // Provider validation
  if (!selectedProvider) {
    tempErrors.provider = "Provider is required";
  }

  setErrors(tempErrors);
  return Object.keys(tempErrors).length === 0;
};

  const [ProviderOption, setProviderOption] = useState([]);
  const [ProcedureOption, setProcedureOption] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const practiceID = localStorage.getItem("default_paractice");
  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Providers/getProviders?practiceId=${practiceID}`,
        {
          headers,
        }
      )
      .then((response) => {
        var prov = [];
        response.forEach((field) => {
          prov.push({
            label: `${field.lastName},${field.firstName}`,
            value: field.nPI,
            taxId: field.taxId,
          });
        });
        setProviderOption(prov);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/Procedures`, {
        headers,
      })
      .then((response) => {
        var prov = [];
        response.forEach((field) => {
          prov.push({
            label: field.code,
            value: field.id,
          });
        });
        setProcedureOption(prov);
      })
      .catch((error) => {});
  }, []);
  const eligibilityInfo = [
    { value: "30", label: "Health Benefit Plan Coverage " },
    { value: "85", label: "AIDS " },
    { value: "84", label: "Abortion " },
    { value: "64", label: "Acupuncture " },
    { value: "28", label: "Adjunctive Dental Services " },
    { value: "57", label: "Air Transportation " },
    { value: "AJ", label: "Alcoholism " },
    { value: "GY", label: "Allergy " },
    { value: "79", label: "Allergy Testing " },
    { value: "15", label: "Alternate Method Dialysis " },
    { value: "13", label: "Ambulatory Service Center Facility " },
    { value: "7", label: "Anesthesia " },
    { value: "97", label: "Anesthesiologist " },
    { value: "71", label: "Audiology Exam " },
    { value: "10", label: "Blood Charges " },
    { value: "91", label: "Brand Name Prescription Drug " },
    { value: "B2", label: "Brand Name Prescription Drug - Formulary " },
    { value: "B3", label: "Brand Name Prescription Drug - Non-Formulary " },
    { value: "B1", label: "Burn Care " },
    { value: "58", label: "Cabulance " },
    { value: "87", label: "Cancer " },
    { value: "BL", label: "Cardiac " },
    { value: "BG", label: "Cardiac Rehabilitation " },
    { value: "CQ", label: "Case Management " },
    { value: "78", label: "Chemotherapy " },
    { value: "33", label: "Chiropractic " },
    { value: "34", label: "Chiropractic Office Visits " },
    { value: "16", label: "Chronic Renal Disease (CRD) Equipment " },
    { value: "BD", label: "Cognitive Therapy " },
    { value: "3", label: "Consultation " },
    { value: "C1", label: "Coronary Care " },
    { value: "BC", label: "Day Care (Psychiatric) " },
    { value: "37", label: "Dental Accident " },
    { value: "35", label: "Dental Care " },
    { value: "36", label: "Dental Crowns " },
    { value: "DG", label: "Dermatology " },
    { value: "DS", label: "Diabetic Supplies " },
    { value: "23", label: "Diagnostic Dental " },
    { value: "5", label: "Diagnostic Lab " },
    { value: "73", label: "Diagnostic Medical " },
    { value: "4", label: "Diagnostic X-Ray " },
    { value: "76", label: "Dialysis " },
    { value: "63", label: "Donor Procedures " },
    { value: "AK", label: "Drug Addiction " },
    { value: "DM", label: "Durable Medical Equipment " },
    { value: "12", label: "Durable Medical Equipment Purchase " },
    { value: "18", label: "Durable Medical Equipment Rental " },
    { value: "86", label: "Emergency Services " },
    { value: "BP", label: "Endocrine " },
    { value: "26", label: "Endodontics " },
    { value: "AR", label: "Experimental Drug Therapy " },
    { value: "BR", label: "Eye " },
    { value: "CP", label: "Eyewear and Eyewear Accessories " },
    { value: "82", label: "Family Planning " },
    { value: "CO", label: "Flu Vaccination " },
    { value: "AM", label: "Frames " },
    { value: "89", label: "Free Standing Prescription Drug " },
    { value: "BN", label: "Gastrointestinal " },
    { value: "60", label: "General Benefits " },
    { value: "92", label: "Generic Prescription Drug " },
    { value: "GF", label: "Generic Prescription Drug - Formulary " },
    { value: "GN", label: "Generic Prescription Drug - Non-Formulary " },
    { value: "BT", label: "Gynecological " },
    { value: "30", label: "Health Benefit Plan Coverage" },
    { value: "42", label: "Home Health Care " },
    { value: "43", label: "Home Health Prescriptions " },
    { value: "44", label: "Home Health Visits " },
    { value: "45", label: "Hospice " },
    { value: "47", label: "Hospital " },
    { value: "53", label: "Hospital - Ambulatory Surgical " },
    { value: "51", label: "Hospital - Emergency Accident " },
    { value: "52", label: "Hospital - Emergency Medical " },
    { value: "48", label: "Hospital - Inpatient " },
    { value: "50", label: "Hospital - Outpatient " },
    { value: "49", label: "Hospital - Room and Board " },
    { value: "80", label: "Immunizations " },
    { value: "61", label: "In-vitro Fertilization " },
    { value: "BA", label: "Independent Medical Evaluation " },
    { value: "83", label: "Infertility " },
    { value: "72", label: "Inhalation Therapy " },
    { value: "IC", label: "Intensive Care " },
    { value: "BS", label: "Invasive Procedures " },
    { value: "AO", label: "Lenses " },
    { value: "59", label: "Licensed Ambulance " },
    { value: "54", label: "Long Term Care " },
    { value: "BM", label: "Lymphatic " },
    { value: "62", label: "MRI/CAT Scan " },
    { value: "90", label: "Mail Order Prescription Drug " },
    { value: "BW", label: "Mail Order Prescription Drug: Brand Name " },
    { value: "BX", label: "Mail Order Prescription Drug: Generic " },
    { value: "55", label: "Major Medical " },
    { value: "CM", label: "Mammogram, High Risk Patient " },
    { value: "CN", label: "Mammogram, Low Risk Patient " },
    { value: "BE", label: "Massage Therapy " },
    { value: "69", label: "Maternity " },
    { value: "27", label: "Maxillofacial Prosthetics " },
    { value: "1", label: "Medical Care " },
    { value: "56", label: "Medically Related Transportation " },
    { value: "MH", label: "Mental Health " },
    { value: "CG", label: "Mental Health Facility - Inpatient " },
    { value: "CH", label: "Mental Health Facility - Outpatient " },
    { value: "CE", label: "Mental Health Provider - Inpatient " },
    { value: "CF", label: "Mental Health Provider - Outpatient " },
    { value: "NI", label: "Neonatal Intensive Care " },
    { value: "BQ", label: "Neurology " },
    { value: "65", label: "Newborn Care " },
    { value: "AQ", label: "Nonmedically Necessary Physical " },
    { value: "BI", label: "Nursery " },
    { value: "BU", label: "Obstetrical " },
    { value: "BV", label: "Obstetrical/Gynecological " },
    { value: "AD", label: "Occupational Therapy " },
    { value: "ON", label: "Oncology " },
    { value: "40", label: "Oral Surgery " },
    { value: "38", label: "Orthodontics " },
    { value: "BK", label: "Orthopedic " },
    { value: "9", label: "Other Medical " },
    { value: "77", label: "Otological Exam " },
    { value: "BB", label: "Partial Hospitalization (Psychiatric) " },
    { value: "66", label: "Pathology " },
    { value: "BH", label: "Pediatric " },
    { value: "24", label: "Periodontics " },
    { value: "88", label: "Pharmacy " },
    { value: "AE", label: "Physical Medicine " },
    { value: "PT", label: "Physical Therapy " },
    { value: "BY", label: "Physician Visit - Office: Sick " },
    { value: "BZ", label: "Physician Visit - Office: Well " },
    { value: "32", label: "Plan Waiting Period " },
    { value: "19", label: "Pneumonia Vaccine " },
    { value: "93", label: "Podiatry " },
    { value: "95", label: "Podiatry - Nursing Home Visits " },
    { value: "94", label: "Podiatry - Office Visits " },
    { value: "17", label: "Pre-Admission Testing " },
    { value: "74", label: "Private Duty Nursing " },
    { value: "CB", label: "Private Duty Nursing - Home " },
    { value: "CA", label: "Private Duty Nursing - Inpatient " },
    { value: "96", label: "Professional (Physician) " },
    { value: "A3", label: "Professional (Physician) Visit - Home " },
    { value: "99", label: "Professional (Physician) Visit - Inpatient " },
    { value: "A1", label: "Professional (Physician) Visit - Nursing Home " },
    { value: "98", label: "Professional (Physician) Visit - Office " },
    { value: "A0", label: "Professional (Physician) Visit - Outpatient " },
    {
      value: "A2",
      label: "Professional (Physician) Visit - Skilled Nursing Facility ",
    },
    { value: "75", label: "Prosthetic Device " },
    { value: "39", label: "Prosthodontics " },
    { value: "A4", label: "Psychiatric " },
    { value: "A7", label: "Psychiatric - Inpatient " },
    { value: "A8", label: "Psychiatric - Outpatient " },
    { value: "A5", label: "Psychiatric - Room and Board " },
    { value: "A6", label: "Psychotherapy " },
    { value: "PU", label: "Pulmonary " },
    { value: "BF", label: "Pulmonary Rehabilitation " },
    { value: "6", label: "Radiation Therapy " },
    { value: "A9", label: "Rehabilitation " },
    { value: "AB", label: "Rehabilitation - Inpatient " },
    { value: "AC", label: "Rehabilitation - Outpatient " },
    { value: "AA", label: "Rehabilitation - Room and Board " },
    { value: "RN", label: "Renal " },
    { value: "14", label: "Renal Supplies in the Home " },
    { value: "RT", label: "Residential Psychiatric Treatment " },
    { value: "46", label: "Respite Care " },
    { value: "25", label: "Restorative " },
    { value: "41", label: "Routine (Preventive) Dental " },
    { value: "AN", label: "Routine Exam " },
    { value: "81", label: "Routine Physical " },
    { value: "CK", label: "Screening X-ray " },
    { value: "CL", label: "Screening laboratory " },
    { value: "20", label: "Second Surgical Opinion " },
    { value: "AG", label: "Skilled Nursing Care " },
    { value: "AH", label: "Skilled Nursing Care - Room and Board " },
    { value: "BJ", label: "Skin " },
    { value: "67", label: "Smoking Cessation " },
    { value: "22", label: "Social Work " },
    { value: "AF", label: "Speech Therapy " },
    { value: "AI", label: "Substance Abuse " },
    { value: "CI", label: "Substance Abuse Facility - Inpatient " },
    { value: "CJ", label: "Substance Abuse Facility - Outpatient " },
    { value: "2", label: "Surgical " },
    { value: "8", label: "Surgical Assistance " },
    { value: "CD", label: "Surgical Benefits - Facility " },
    { value: "CC", label: "Surgical Benefits - Professional (Physician) " },
    { value: "21", label: "Third Surgical Opinion " },
    { value: "TC", label: "Transitional Care " },
    { value: "TN", label: "Transitional Nursery Care " },
    { value: "70", label: "Transplants " },
    { value: "UC", label: "Urgent Care " },
    { value: "11", label: "Used Durable Medical Equipment " },
    { value: "AL", label: "Vision (Optometry) " },
    { value: "68", label: "Well Baby Care " },
  ];

  const relationshipOptions = [
    { value: 18, label: "Self" },
    { value: 19, label: "Spouse" },
    { value: 20, label: "Mother" },
    { value: 21, label: "Father" },
    { value: 22, label: "Other" },
  ];

  const parseClaimMdResponse = (data) => {
    // Case 1: Root-level error (like Tax ID, Provider, Auth issues)
    if (data?.error?.error_code) {
      return {
        status: "error",
        title: "Claim.MD Error",
        message: `[${data.error.error_code}] ${data.error.error_mesg}`,
      };
    }

    // Case 2: Eligibility error inside elig.error[]
    if (data?.elig?.error?.length > 0) {
      return {
        status: "error",
        title: "Eligibility Error",
        message: data.elig.error
          .map((e, i) => `${i + 1}. [${e.error_code}] ${e.error_mesg}`)
          .join("\n"),
      };
    }

    // Case 3: Valid eligibility response
    if (data?.elig?.eligid) {
      return {
        status: "success",
        title: "Eligibility Verified",
        message:
          `Eligibility ID: ${data.elig.eligid}\n` +
          `Subscriber: ${data.elig.ins_name_f} ${data.elig.ins_name_l}\n` +
          `DOB: ${data.elig.ins_dob}`,
      };
    }

    // Case 4: Fallback
    return {
      status: "error",
      title: "Unknown Response",
      message: "Unexpected response received from Claim.MD",
    };
  };

  const handleSubmit = async (e) => {
       e.preventDefault(); 
  if (!validateForm()) return;
    // e.preventDefault();
    // if (!selectedInsurance || !selectedProvider || !procedureCode) {
    //   Swal.fire({
    //     icon: "error",
    //     title: "Validation Error",
    //     html: `<pre style="text-align:left;">Please fill all required fields before submitting.</pre>`,
    //     confirmButtonColor: "#E74C3C",
    //     width: 600,
    //     willOpen: () => {
    //       // Set z-index before popup opens
    //       const swalPopup = document.querySelector(".swal2-container");
    //       if (swalPopup) swalPopup.style.zIndex = 2200;
    //     },
    //   });
    //   return;
    // }

    const formData = {
      proc_code: procedureCode,
      ins_name_l: lastName,
      ins_name_f: firstName,
      pat_rel: relationship,
      ins_number: policyNumber,
      ins_dob: dob,
      fdos: dos,
      service_code: benefitType,
      patientId: props.patientId,
      planName: selectedInsurance.label,
      prov_npi: selectedProvider?.value?.trim(),
      prov_taxid: String(selectedProvider?.taxId).trim(),
      payerid: selectedInsurance.value,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Eligibility/sendRequestClaimMd`,
        formData,
        { headers }
      );

      const parsed = parseClaimMdResponse(response);

      Swal.fire({
        icon: parsed.status,
        title: parsed.title,
        html: `<pre style="text-align:left; max-height:350px;">${parsed.message}</pre>`,
        confirmButtonColor: parsed.status === "error" ? "#E74C3C" : "#356F60",
        width: 600,
        timer: parsed.status === "success" ? 2000 : undefined, // 3 seconds
        showConfirmButton: parsed.status === "error", // OK button only for error
        timerProgressBar: parsed.status === "success",
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      }).then(() => {
        if (parsed.status === "success") {
          props.handleCancel();
        }
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        html: `<pre style="text-align:left;">${error.message}</pre>`,
        confirmButtonColor: "#E74C3C",
        width: 600,
        willOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = 2200;
        },
      });
    }
  };

  const resetForm = () => {
    setPayer({ value: "AARP", label: "AARP" });
    setProvider("");
    setBenefitType({
      value: "Health Benefit Plan Coverage",
      label: "Health Benefit Plan Coverage",
    });
    setProcedureCode("");
    setLastName("");
    setFirstName("");
    setRelationship();
    setPolicyNumber("");
    setDob("");
    setDos("");
  };

  return (
    <Container maxWidth="lg">
      <form onSubmit={handleSubmit}>
        <Box
          sx={{
            border: "1px solid #d0d0d0",
            borderRadius: 2,
            p: 3,
            width: "100%",
            // maxWidth: 900,
            backgroundColor: "#fafafa",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            {/* Row 1: Patient Insurance / Insurance Company */}
            <Grid item xs={5.5} display="flex" justifyContent="space-between">
              <Box display="flex" flexDirection="column">
                <Typography variant="body2" color="textSecondary">
                  Patient Name
                </Typography>
                <Typography variant="body1" fontWeight={500} color="black">
                  {lastName}, {firstName}
                </Typography>
              </Box>
              <Box display="flex" flexDirection="column">
                <Typography variant="body2" color="textSecondary">
                  Patient's DOB
                </Typography>
                <Typography variant="body1" fontWeight={500} color="black">
                  {dob} {/* Format as needed */}
                </Typography>
              </Box>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
            <Grid
              item
              xs={5.8}
              display="flex"
              justifyContent="space-between"
              gap={2}
            >
              <Box sx={{ position: "relative", width: "100%" }}>
                <Typography variant="body2" color="textSecondary">
                  Insurance Company:
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Search Insurance..."
                  value={inputValue}
                  onChange={(e) => handleSearch(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {loading ? (
                          <CircularProgress size={18} />
                        ) : (
                          <SearchIcon />
                        )}
                      </InputAdornment>
                    ),
                  }}
                     error={Boolean(errors.insurance)}
    helperText={errors.insurance}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 2,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />

                {options.length > 0 && (
                  <Paper
                    elevation={3}
                    sx={{
                      position: "absolute",
                      width: "100%", // matches TextField
                      maxHeight: 220,
                      overflowY: "auto",
                      mt: 0.5,
                      zIndex: 1000,
                      borderRadius: 2,
                      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                    }}
                  >
                    <List dense>
                      {options.map((option, idx) => (
                        <React.Fragment key={option.value}>
                          <ListItem
                            button
                            sx={{
                              py: 1.2,
                              px: 2,
                              "&:hover": { backgroundColor: "#e3f2fd" },
                              cursor: "pointer",
                            }}
                            onClick={() => handleSelect(option)}
                          >
                            <span style={{ fontWeight: 500, color: "#344767" }}>
                              {option.value} –{" "}
                              {highlightMatch(option.label, inputValue)}
                            </span>
                          </ListItem>

                          {/* Divider between items except the last one */}
                          {idx < options.length - 1 && (
                            <div
                              style={{
                                height: 1,
                                backgroundColor: "#e0e0e0",
                                margin: "0 8px",
                              }}
                            />
                          )}
                        </React.Fragment>
                      ))}
                    </List>
                  </Paper>
                )}
              </Box>
              <Box sx={{ position: "relative", width: "100%" }}>
                <Typography variant="body2" color="textSecondary">
                  Provider *
                </Typography>
                <Select
                  // value={ProviderOption?.find(
                  //   (option) => option.value == selectedProvider
                  // )}
                  value={selectedProvider}
                  onChange={(option) => setSelectedProvider(option)}
                  // onChange={(option) => setSelectedProvider(option.value)}
                  options={ProviderOption}
                  isSearchable
                  size="small"
                />
                 {errors.provider && (
    <Typography variant="caption" color="error">
      {errors.provider}
    </Typography>
  )}
              </Box>
            </Grid>

            <Grid item xs={5.5} display="flex" justifyContent="space-between">
              <Box display="flex" flexDirection="column">
                <Typography variant="body2" color="textSecondary">
                  Member Id
                </Typography>
                <Typography variant="body1" fontWeight={500} color="black">
                  {policyNumber}
                </Typography>
              </Box>
              <Box display="flex" flexDirection="column">
                <Typography variant="body2" color="textSecondary">
                  Patient's Relation
                </Typography>
                <Typography variant="body1" fontWeight={500} color="black">
                  {"Self"}
                </Typography>
              </Box>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
            <Grid
              item
             xs={5.8}
              display="flex"
              justifyContent="space-between"
              gap={2}
            >
              <Box sx={{ position: "relative", width: "100%" }}>
                <Typography variant="body2" color="textSecondary">
                  Benefit Type *
                </Typography>
                <Select
                  value={eligibilityInfo?.find(
                    (option) => option.value == benefitType
                  )}
                  onChange={(option) => setBenefitType(option.value)}
                  size="small"
                  options={eligibilityInfo}
                />
              </Box>
              <Box sx={{ position: "relative", width: "100%" }}>
                <Typography variant="body2" color="textSecondary">
                  Procedure Code *
                </Typography>
                <Select
                  value={ProcedureOption?.find(
                    (option) => option.value == procedureCode
                  )}
                  onChange={(option) => setProcedureCode(option.label)}
                  options={ProcedureOption}
                  isSearchable
                  size="small"
                />
              </Box>
            </Grid>

            {/* Row 3: To Date / Procedure Code */}
            <Grid item xs={5.5}>
              {/* <Typography variant="body2" color="textSecondary">
                To Date:
              </Typography>
              <TextField
                fullWidth
                size="small"
                type="date"
                value="2026-01-03"
              /> */}
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
            <Grid item  xs={5.8}>
              <Typography variant="body2" color="textSecondary">
                Date of Service:
              </Typography>
                <TextField
              fullWidth
              type="date"
              size="small"
              value={dos}
              onChange={(e) => setDos(e.target.value)}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
            </Grid>
                 <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 3,
              }}
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={props.handleCancel}
                size="large"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                sx={{ px: 4 }}
              >
                Check Eligibility
              </Button>
            </Box>
          </Grid>
          </Grid>
        </Box>
        {/* <Grid container spacing={1}>
          <Grid item xs={12} md={6} sx={{ position: "relative" }}>
            <Typography variant="subtitle2" gutterBottom>
              Payer *
            </Typography>
            
            <TextField
              fullWidth
              size="small"
              placeholder="Search Insurance..."
              value={inputValue}
              onChange={(e) => handleSearch(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {loading ? <CircularProgress size={18} /> : <SearchIcon />}
                  </InputAdornment>
                ),
              }}
              sx={{
                backgroundColor: "#fff",
                borderRadius: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />

            {options.length > 0 && (
              <Paper
                elevation={3}
                sx={{
                  position: "absolute",
                  width: "100%", // matches TextField
                  maxHeight: 220,
                  overflowY: "auto",
                  mt: 0.5,
                  zIndex: 1000,
                  borderRadius: 2,
                  boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
                }}
              >
                <List dense>
                  {options.map((option, idx) => (
                    <React.Fragment key={option.value}>
                      <ListItem
                        button
                        sx={{
                          py: 1.2,
                          px: 2,
                          "&:hover": { backgroundColor: "#e3f2fd" },
                          cursor: "pointer",
                        }}
                        onClick={() => handleSelect(option)}
                      >
                        <span style={{ fontWeight: 500, color: "#344767" }}>
                          {option.value} –{" "}
                          {highlightMatch(option.label, inputValue)}
                        </span>
                      </ListItem>

                      {idx < options.length - 1 && (
                        <div
                          style={{
                            height: 1,
                            backgroundColor: "#e0e0e0",
                            margin: "0 8px",
                          }}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </List>
              </Paper>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Provider *
            </Typography>
            <Select
              // value={ProviderOption?.find(
              //   (option) => option.value == selectedProvider
              // )}
              value={selectedProvider}
              onChange={(option) => setSelectedProvider(option)}
              // onChange={(option) => setSelectedProvider(option.value)}
              options={ProviderOption}
              isSearchable
              size="small"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Benefit Type *
            </Typography>
            <Select
              value={eligibilityInfo?.find(
                (option) => option.value == benefitType
              )}
              onChange={(option) => setBenefitType(option.value)}
              size="small"
              options={eligibilityInfo}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Procedure Code *
            </Typography>
         
            <Select
              value={ProcedureOption?.find(
                (option) => option.value == procedureCode
              )}
              onChange={(option) => setProcedureCode(option.label)}
              options={ProcedureOption}
              isSearchable
              size="small"
            />
          </Grid>

          <Grid item xs={12}>
            <Divider>
              <Typography variant="h6" color="primary">
                Subscriber Information
              </Typography>
            </Divider>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              First Name
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Last Name
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Relationship *
            </Typography>
            <Select
              value={relationshipOptions?.find(
                (option) => option.value == relationship
              )}
              onChange={(option) => setRelationship(option.value)}
              options={relationshipOptions}
              size="small"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Member Id
            </Typography>
            <TextField
              fullWidth
              value={policyNumber}
              size="small"
              onChange={(e) => setPolicyNumber(e.target.value)}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Date of Birth
            </Typography>
            <TextField
              fullWidth
              type="date"
              value={dob}
              size="small"
              onChange={(e) => setDob(e.target.value)}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Date of Service
            </Typography>
            <TextField
              fullWidth
              type="date"
              size="small"
              value={dos}
              onChange={(e) => setDos(e.target.value)}
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 3,
              }}
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={props.handleCancel}
                size="large"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                sx={{ px: 4 }}
              >
                Check Eligibility
              </Button>
            </Box>
          </Grid>
        </Grid> */}
      </form>
    </Container>
  );
};

export default EligibilityCheck;
